import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { FaEdit, FaTrashAlt, FaCog } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import { toast } from "react-toastify";

function ActionDropdown({ id, user, refetchData }) {
  const navigate = useNavigate();
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/socialmedia/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Successfully deleted social media link");
        refetchData();
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Failed to delete social media link"
        );
      });
  };

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-d-bg-text" />
          <IoIosArrowDown className="text-d-bg-text" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <button
            onClick={() => {
              navigate("editSocialMedia/" + id);
              setShowDropDown(false);
            }}
            className="text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
          >
            <FaEdit />
            <p>{languageHelper("Edit")}</p>
          </button>
          <button
            onClick={() => setShowDelModal(true)}
            className="text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
          >
            <FaTrashAlt />
            <p>{languageHelper("Delete")}</p>
          </button>
        </div>
      </div>
      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-d-bg-text font-semibold text-xl text-center">
                {languageHelper("Alert!") || "Alert!"}
              </h1>
              <p className="text-center text-gray-700">
                {languageHelper("Are you sure?")}
              </p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                {languageHelper("No") || "No"}
              </button>
              <button
                onClick={handleDelete}
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                {languageHelper("Yes") || "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function SocialMedia() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const fetchSocialMedia = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/socialmedia`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((response) => {
        setData(response.data);
        setPageLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching social media data:", err);
        setPageLoading(false);
      });
  }, [user?.token]);

  const [columns] = useState([
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Icon"),
      accessorKey: "icon_url",
      cell: (row) =>
        row.getValue() ? (
          <img className="w-8 h-8 object-contain" src={row.getValue()} alt="" />
        ) : (
          "-"
        ),
    },
    {
      header: languageHelper("Name"),
      accessorKey: "name",
    },
    {
      header: languageHelper("Link"),
      accessorKey: "link",
    },

    {
      header: languageHelper("Status"),
      accessorKey: "status",
      cell: (row) => (
        <input
          type="checkbox"
          className="theme-checkbox"
          checked={row.getValue() === "active"}
          onChange={(e) =>
            handleStatusChange(row.row.original.id, row.getValue())
          }
        ></input>
      ),
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "SN",
      cell: (row) => (
        <ActionDropdown
          id={row.row.original.id}
          user={user}
          refetchData={fetchSocialMedia}
        />
      ),
    },
  ]);

  const buttonData = [
    {
      buttonText: languageHelper("Add Social Media"),
      path: "AddSocialMedia",
    },
  ];

  const handleStatusChange = (id, status) => {
    axios
      .put(
        `${apiKey}/api/rms/admin/socialmedia/${id}`,
        {
          status: status === "active" ? "inactive" : "active",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        // Update the local data state to reflect the change
        setData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, status: status === "active" ? "inactive" : "active" }
              : item
          )
        );
        toast.success(
          res.data.message || "Successfully updated social media link"
        );
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Failed to update social media link"
        );
      });
  };

  useEffect(() => {
    setPageLoading(true);
    fetchSocialMedia();
  }, [fetchSocialMedia]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Social Media")}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

export default SocialMedia;
